<template>
  <div class="p_pro_content">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>项目</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/projectList' }">项目列表</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_pro_table" v-loading="listLoading">
        <el-tabs v-model="activeName" @tab-click="changeTab" v-if="isEdit=='true' && checkPermission(['projectList_acSet'],permissionLists)">
          <el-tab-pane label="基本信息" name="0"></el-tab-pane>
          <el-tab-pane label="账套" name="1"></el-tab-pane>
        </el-tabs>
        <!-- <div class="error_txt">
            <div v-for="(item, index) in selServiceList" :key="index" class="error_item">
              <p>温馨提示:{{item}}客服非您负责区域的客服人员,请确认！</p>
              <i class="el-icon-close" @click="dltErrorHandle(index)"></i>
            </div>
          </div> -->
        <el-form :model="proForm" :rules="rules" :inline="true" ref="proForm" class="pro-form-inline add_form" label-width="120px">
          <el-form-item label="项目名称:" prop="strprojectName">
            <el-autocomplete style="width:300px;" value-key="StrprojectName" v-model="proForm.strprojectName" :disabled="isDetail" clearable :fetch-suggestions="querySearch" placeholder="请输入项目名称" @select="handleSelect"></el-autocomplete>
          </el-form-item>
          <el-form-item label="立项时间:" prop="dtInitDate">
            <el-date-picker type="date" clearable value-format="yyyy-MM-dd" placeholder="请选择立项时间" v-model="proForm.dtInitDate" :disabled="isDetail"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="客户简称:" prop="cusName">
              <el-input
                v-model="proForm.cusName" :disabled="isDetail"
                placeholder="请输入客户简称"
              ></el-input>
            </el-form-item> -->
          <el-form-item label="客户名称:" prop="custid">
            <el-select v-model="proForm.custid" filterable clearable placeholder="请选择客户名称" :disabled="isDetail">
              <el-option v-for="(item, index) in customList" :key="index" :label="item.StrCustName" :value="item.Custid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目等级:" prop="strprojectlevel">
            <el-select v-model="proForm.strprojectlevel" placeholder="请选择项目等级" clearable :disabled="isDetail">
              <el-option v-for="(item, index) in levelList" :key="index" :label="item.StrCustprolevelName" :value="item.Custprolevelid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="实操业务类型:" prop="actualtype">
            <el-select v-model="proForm.actualtype" filterable placeholder="请选择实际操作业务类型" clearable :disabled="isDetail">
              <el-option v-for="(item, index) in businessList" :key="index" :label="item.StrBusitypeName" :value="item.Busitypeid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地区:" prop="entNation" class="pro_area">
            <!-- <div
              ref="entRegion"
              :style="{'pointer-events':(isDetail?'none':'all')}"
            >
              <MRegion :cityGet="true"
                :fullrange="true"
                :selected="selected"
                :search="true"
                @cRegion="changeArea"
              />
            </div> -->
            <el-cascader :props="propsAddress" filterable ref="cascaderArr" clearable :placeholder="cascaderTxt" :disabled="isDetail" v-model="selected" :options="areaList" @change="changeAreaHandle"></el-cascader>
          </el-form-item>
          <el-form-item label="业绩归属部门:" prop="strbusdep">
            <el-cascader v-model="perDepartList" :disabled="isDetail" :props="props" clearable filterable :options="departList" placeholder="请选择业绩归属部门" @change="perSectionChange"></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="业绩归属子部门:" prop="strbussondep">
              <el-select
                  v-model="proForm.strbussondep"
                  placeholder="请选择业绩归属子部门" :disabled="isDetail"
                >
                  <el-option
                    v-for="item in departList"
                    :key="item.strorgancode"
                    :label="item.strorganname"
                    :value="item.strorgancode">
                  </el-option>
                </el-select>
            </el-form-item> -->
          <el-form-item label="业务团队长:" prop="strpartner">
            <el-select v-model="proForm.strpartner" filterable clearable @change="partnerSelChange" placeholder="请选择业务团队长" :disabled="isDetail">
              <el-option v-for="(item, index) in leaderList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业绩归属人部门:" prop="strAchievedep">
            <el-cascader v-model="perOwnerList" :disabled="isDetail" :props="props" clearable filterable :options="departList" placeholder="请选择业绩归属人部门" @change="ownerSectionChange"></el-cascader>
          </el-form-item>
          <el-form-item label="业绩归属人:" prop="strAchieveowner">
            <el-select v-model="proForm.strAchieveowner" filterable clearable @change="achieveownerChange" placeholder="请选择业绩归属人" :disabled="isDetail">
              <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务部门:">
            <el-cascader v-model="dedpartNameList" ref="dep" :disabled="isDetail" :props="props" clearable filterable :options="departList" placeholder="请选择服务部门" @change="handleSectionChange"></el-cascader>
          </el-form-item>
          <el-form-item label="客服:" prop="editCusIds">
            <el-select v-model="proForm.editCusIds" filterable clearable multiple placeholder="请选择客服" :disabled="isDetail" @change="servuserChange">
              <el-option v-for="(item, index) in customerList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合伙人:" prop="strpartner2">
            <el-select v-model="proForm.strpartner2" filterable clearable placeholder="请选择合伙人" :disabled="isDetail" @change="strpartner2Change">
              <el-option v-for="(item, index) in partnerList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目管理员:" prop="strProManager">
            <el-select v-model="proForm.strProManager" filterable clearable placeholder="请选择项目管理员" :disabled="isDetail" @change="proManagerChange">
              <el-option v-for="(item, index) in staffList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否招聘:" prop="strrecruit">
            <el-select v-model="proForm.strrecruit" placeholder="请选择是否招聘" :disabled="isDetail" clearable>
              <el-option label="需招聘" value="需招聘"></el-option>
              <el-option label="无需招聘" value="无需招聘"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否转移:" prop="strTransfer">
            <el-select v-model="proForm.strTransfer" placeholder="请选择是否转移" :disabled="isDetail" clearable>
              <el-option label="有转移" value="有转移"></el-option>
              <el-option label="无转移" value="无转移"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协议高风险:" prop="strHighRisk">
            <el-select v-model="proForm.strHighRisk" placeholder="请选择协议高风险" :disabled="isDetail" clearable>
              <el-option label="高风险承担50%" value="高风险承担50%"></el-option>
              <el-option label="正常风险" value="正常风险"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否新增:" prop="strNewadd">
            <el-select v-model="proForm.strNewadd" placeholder="请选择是否新增" :disabled="isDetail" clearable>
              <el-option label="新增" value="新增"></el-option>
              <el-option label="不列新增" value="不列新增"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="社保:" prop="socialInsuranceList">
            <el-select v-model="proForm.socialInsuranceList" multiple @change="$forceUpdate()" placeholder="请选择社保" :disabled="isDetail" clearable>
              <el-option v-for="(item, index) in socialSecurityList" :key="index" :label="item.StrSocialsecName" :value="item.StrSocialsecName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商保:" prop="busInsuranceList">
            <el-select v-model="proForm.busInsuranceList" multiple @change="$forceUpdate()" placeholder="请选择商保" :disabled="isDetail" clearable>
              <el-option v-for="(item, index) in insuranceList" :key="index" :label="item.StrBusisecName" :value="item.StrBusisecName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计提风险金:" prop="decRiskfund">
            <el-select v-model="proForm.decRiskfund" placeholder="请选择是否计提风险金" :disabled="isDetail" clearable>
              <el-option label="计提" value="计提"></el-option>
              <el-option label="不计提" value="不计提"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型:" prop="strBillmethod">
            <el-select v-model="proForm.strBillmethod" placeholder="请选择发票类型" :disabled="isDetail" clearable>
              <el-option label="专票" value="专票"></el-option>
              <el-option label="普票" value="普票"></el-option>
              <el-option label="专票+普票" value="专票+普票"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票方式:" prop="strinvoiceType">
            <el-select v-model="proForm.strinvoiceType" placeholder="请选择开票方式" :disabled="isDetail" clearable>
              <el-option label="全额" value="全额"></el-option>
              <el-option label="差额" value="差额"></el-option>
              <el-option label="全额+差额" value="全额+差额"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票内容:" prop="strInvoicecontent">
            <el-input v-model="proForm.strInvoicecontent" :disabled="isDetail" clearable placeholder="请输入开票内容"></el-input>
          </el-form-item>
          <el-form-item label="发薪日期:" prop="dtpaydate">
            <el-select v-model="proForm.dtpaydate" filterable placeholder="请选择发薪日期" :disabled="isDetail" clearable>
              <el-option v-for="(item, index) in paydateList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否垫资:" prop="isAdvMoney">
            <el-select v-model="proForm.isAdvMoney" placeholder="请选择是否垫资" :disabled="isDetail" clearable>
              <el-option label="垫支" value="垫支"></el-option>
              <el-option label="不垫支" value="不垫支"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="签约主体:" prop="strSignsubject">
            <el-select v-model="proForm.strSignsubject" filterable placeholder="请选择签约主体" :disabled="isDetail" clearable>
              <el-option v-for="(item, index) in legalList" :key="index" :label="item.StrLegalsubName" :value="item.Legalsubid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同业务类型:" prop="strContractType">
            <el-select v-model="proForm.strContractType" filterable placeholder="请选择合同业务类型" :disabled="isDetail" clearable>
              <el-option v-for="(item, index) in businessList" :key="index" :label="item.StrBusitypeName" :value="item.Busitypeid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同起始时间:" prop="dtContractstartDate">
            <el-date-picker type="date" clearable value-format="yyyy-MM-dd" placeholder="请选择合同起始时间" v-model="proForm.dtContractstartDate" :disabled="isDetail"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同到期时间:" prop="dtContractendDate">
            <el-date-picker type="date" clearable value-format="yyyy-MM-dd" placeholder="请选择合同到期时间" v-model="proForm.dtContractendDate" :disabled="isDetail"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同负责人:" prop="strContleader">
            <el-select v-model="proForm.strContleader" filterable clearable placeholder="请选择合同负责人" :disabled="isDetail" @change="contleaderChange">
              <el-option v-for="(item, index) in staffList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="项目查看人:" prop="strViewids">
            <el-select v-model="viewidList" filterable clearable multiple placeholder="请选择项目查看人" :disabled="isDetail" @change="$forceUpdate()">
              <el-option v-for="(item, index) in viewsList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户人员:" prop="StrCustomerid">
            <el-select v-model="customeridList" filterable clearable multiple placeholder="请选择客户人员" :disabled="isDetail" @change="$forceUpdate()">
              <el-option v-for="(item, index) in viewsList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 签约信息 -->
        <div class="page_title_box">
          <div class="p_line"></div>
          <div class="p_line_title">签约信息</div>
        </div>
        <div class="page_table_box">
          <el-table v-loading="tableLoading" border :data="tableData" style="width:100%">
            <el-table-column align="center" label="签约主体" width="180px" fixed="left">
              <template slot-scope="{row}">
                <el-select @change="forceChange" v-model="row.strSignsubject" :disabled="isEdit == 'detail'" placeholder="" size="small" filterable clearable>
                  <el-option v-for="(item, index) in legalList" :key="index" :label="item.StrLegalsubName" :value="item.Legalsubid"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="合同业务类型" min-width="180px">
              <template slot-scope="{row}">
                <el-select @change="forceChange" v-if="row.type == 'add'&&isEdit != 'detail'" v-model="row.strContractType" size="small" placeholder="" clearable>
                  <el-option v-for="(item, index) in businessList" :key="index" :label="item.StrBusitypeName" :value="item.Busitypeid">
                  </el-option>
                </el-select>
                <span v-else>{{row.strContractTypeName}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="合同负责人" min-width="180px">
              <template slot-scope="{row}">
                <el-select @change="forceChange" v-if="row.type == 'add'&&isEdit != 'detail'" v-model="row.strContleader" filterable size="small" clearable placeholder="">
                  <el-option v-for="(item, index) in staffList" :key="index" :label="item.Username" :value="item.Userid">
                  </el-option>
                </el-select>
                <span v-else>{{row.strContleaderName}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="合同开始时间" min-width="180px">
              <template slot-scope="{row}">
                <el-date-picker @change="forceChange" v-if="row.type == 'add'&&isEdit != 'detail'" type="date" size="small" clearable value-format="yyyy-MM-dd" placeholder="" v-model="row.dtContractstartDate"></el-date-picker>
                <span v-else>{{row.dtContractstartDate}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="合同结束时间" min-width="180px">
              <template slot-scope="{row}">
                <el-date-picker @change="forceChange" v-if="row.type == 'add'&&isEdit != 'detail'" type="date" size="small" clearable value-format="yyyy-MM-dd" placeholder="" v-model="row.dtContractendDate"></el-date-picker>
                <span v-else>{{row.dtContractendDate}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="合同附件" min-width="180px">
              <template slot-scope="{row}">
                <el-upload class="upload-demo" v-if="isEdit != 'detail'" accept=".doc,.docx,.pdf,.xls,.xlsx" ref="file" action="#" :show-file-list="row.type == 'add'?true:false" :file-list="row.contractList" :on-change="(file, fileList)=>{return success_handle(file,fileList,row)}" :auto-upload="false" :limit="3" :on-remove="(file, fileList)=>{return handleFileRemove(file,fileList,row)}" :on-exceed="handleExceed">
                  <el-button size="small" type="text">上传</el-button>
                </el-upload>
                <div v-if="row.type == 'dtl'">
                  <div v-for="(item,index) in row.contractList" :key="index" class="f_txt">
                    <span class="w_txt" :title="item.name" @click="downHandle(item)">{{item.name}}</span>
                    <i v-if="isEdit != 'detail'" class="el-icon-error err_icon" @click="dltItemHandle(item,index,row.contractList)"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="90px" fixed="right" v-if="isEdit != 'detail'">
              <template slot-scope="{row,$index}">
                <el-button v-if="row.type == 'add'" type="primary" size="mini" plain @click="addHandle(row)">新增</el-button>
                <el-button v-if="row.type == 'dtl'" type="primary" size="mini" plain @click="dltHandle($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 项目简介 -->
        <div class="page_title_box mt15">
          <div class="p_line"></div>
          <div class="p_line_title">项目简介</div>
        </div>
        <el-form :model="proForm" ref="proInfoForm" class="info_form" label-width="120px">
          <el-form-item label="项目图片:">
            <el-upload action="#" v-if="isEdit != 'detail'" ref="uploadPro" class="pic_up" :accept="'image/jpeg, image/png, image/jpg'" :before-upload="beforeAvatarUpload" list-type="picture-card" :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,picListPro)}" :on-exceed="handleExceedPic" :auto-upload="false" :multiple="true" :limit="10" :file-list="picListPro">
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" class="up_box">
                <img class="el-upload-list__item-thumbnail" :src="docPath+file.StrPicture" alt="">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="handleRemove(file,picListPro)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <div v-else class="info_pic_box">
              <div class="info_pic_item" v-for="(item,index) in picListPro" :key="index">
                <el-image style="width: 100px; height: 100px" :src="docPath+item.StrPicture" :preview-src-list="[docPath+item.StrPicture]">
                </el-image>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="项目简介:">
            <el-input v-model="proForm.StrIntroduct" placeholder="" :disabled="isEdit == 'detail'" type="textarea" rows="8" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="page_btn_box">
          <el-button @click="backHandle">返回</el-button>
          <el-button type="primary" @click="submitForm('proForm')" :loading="btnLoading" :disabled="isDetail">保存</el-button>
        </div>
      </div>
    </div>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisiblePic">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  import xz from "@/common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    name: "serviceCenter",
    data() {
      return {
        listLoading: false,
        btnLoading: false,
        dialogVisiblePic: false,
        dialogImageUrl: '',
        docPath: this.$store.state.EMP.docPath,
        imgPath: this.$store.state.EMP.imgPath,
        // 选中的负责客服人员列表
        selServiceList: [],
        isDetail: false,
        pageTitle: '新增项目',
        // 项目名称列表
        proNameList: [],
        // 项目名称列表参数
        proNameQuery: {
          projectname: '', // 项目名称
          projectid: '', // 项目id
          custname: '', //客户名称
          strAchieveowner: '', // 业绩归属人
          strservuserid: '', // 客服
          strBusiStat: '', //项目状态
          strpartner2: '', //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: '',
          roletype: ''
        },
        // 项目等级列表
        levelList: [],
        // 实操业务类型列表
        businessList: [],
        // 业绩归属部门列表
        belongList: [],
        // 业绩归属子部门列表
        belongChildList: [],
        // 业务团队长列表
        leaderList: [],
        // 客服列表
        customerList: [],
        // 业绩归属人列表
        belongOwnerList: [],
        // 客服列表
        cusServiceList: [],
        // 员工列表
        staffList: [],
        // 合伙人
        partnerList: [],
        // 项目管理员列表
        adminList: [],
        // 业绩归属人
        memberList: [],
        // 项目查看人列表
        viewsList: [],
        // 部门列表
        departList: [],
        // 多级部门列表
        sectionList: [],
        // 选中的多级部门
        dedpartNameList: [],
        // 选中的业绩归属部门
        perDepartList: [],
        // 选中的业绩归属人部门
        perOwnerList: [],
        // 发薪日期
        paydateList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
        // 法务主体
        legalList: [],
        tableHeight: 0,
        tableLoading: false,
        rules: {
          custid: [{
            required: true,
            message: '请输入客户名称',
            trigger: 'blur'
          }],
          strprojectName: [{
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }],
          dtInitDate: [{
            required: true,
            message: '请选择立项时间',
            trigger: 'change'
          }],
          editCusIds: [{
            type: 'array',
            required: true,
            message: '请选择客服',
            trigger: 'change'
          }]
        },
        isEdit: false,
        // 客户列表参数
        listQuery: {
          currpage: 1,
          perpage: 10000000,
          strorgancode: '',
          roletype: '',
          strCustlevel: '', // 客户等级
          strProvince: '', // 省
          strCity: '', // 市
          custname: '', //客户名称
          username: '', //业务员
          depname: '', //业务部门
          groupname: '', //所属集团
          strCustType: '', //客户类别
          strCustindust: '' //客户行业
        },
        // 新增/编辑项目信息参数
        proForm: {
          projectid: '', //项目id
          strprojectName: '', //项目名称
          custid: '', //客户id
          dtInitDate: '', //立项时间
          strSignsubject: '', //签约主体
          strContractType: '', //合同业务类型
          actualtype: '', //业务类型
          strprojectlevel: '', //项目等级
          strProProvince: '', //省
          strProCity: '', //市
          strbusdep: '', //业绩归属部门
          // strbussondep:'', //业绩归属子部门
          strpartner: '', //业务团队长
          strpartner2: '', //合伙人
          strAchieveowner: '', //业绩归属人
          strAchievedep: '', //业绩归属人部门
          strservuserid: '', //客服
          strProManager: '', //项目管理员
          strBusiStat: '合作中', //项目状态
          strrecruit: '', //是否招聘
          strTransfer: '', //是否转移
          strHighRisk: '', //协议高风险
          strNewadd: '', //是否新增
          socialInsurance: '', //社保
          socialInsuranceList: [], //社保多选
          busInsurance: '', //商保
          busInsuranceList: [], //商保多选
          decRiskfund: '', //风险计提金
          strinvoiceType: '', //开票方式
          strInvoicecontent: '', //发票内容
          strBillmethod: '', //发票类型
          dtpaydate: '', //发薪日期
          isAdvMoney: '', //是否垫资
          dtEndDate: '1900-01-01', //项目终止时间
          dtContractstartDate: '', //合同开始时间
          dtContractendDate: '', //合同结束时间
          strContleader: '', //合同负责人
          strDep1: '', //部门一级
          strDep2: '', //部门二级
          strDep3: '', //部门三级
          strRegion: '', //地区码
          editCusIds: [],
          strViewids: '', //项目查看人
          StrCustomerid: '', //客户人员
          StrIntroduct: '' //简介
        },
        // 选中的查看人
        viewidList: [],
        // 选中的地区code
        selected: [],
        // 客户列表
        customList: [],
        // 社保
        socialSecurityList: [],
        // 商保
        insuranceList: [],
        // 参数列表参数
        paramQuery: {
          currpage: 1,
          perpage: 100000,
          keyword: '',
          strIsDisable: '1', // 传1 禁用的看不到了  不传就全显示
          // JB_base_Busitype 业务类型 JB_base_Custprolevel客户项目等级 
          // JB_base_Jobfunclabel 岗位职能标签 JB_base_Socialsec社保 JB_base_Busisec 商保
          strtableid: ''
        },
        // 部门参数
        departQuery: {
          strorgancode: '',
          roletype: ''
        },
        // 员工参数
        departMemberQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        },
        // select是否有改变
        isLeaderChange: false,
        isproManagerChange: false,
        isStrpartner2Change: false,
        isServuserChange: false,
        isAchieveownerChange: false,
        isPartnerSelChange: false,
        // 人员详情的id
        dtlOneQuery: {
          strpartner: '', //业务团队长
          strpartner2: '', //合伙人
          strAchieveowner: '', //业绩归属人
          strservuserid: '', //客服
          strProManager: '', //项目管理员
          strContleader: '' //合同负责人
        },
        // 区域的数据
        areaCityList: [],
        areaProvinceList: [],
        areaList: [],
        propsAddress: {
          label: 'Name',
          value: 'Name',
          children: 'children',
          multiple: true,
          // checkStrictly: true
        },
        // 自定义 级联选择props
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        activeName: '0',
        permissionLists: [],
        tableData: [{
          type: 'add',
          Subid: '',
          strSignsubject: '', //签约主体
          strContractType: '', //合同业务类型
          strContractTypeName: '', //合同业务类型名称
          dtContractstartDate: '', //合同开始时间
          dtContractendDate: '', //合同结束时间
          strContleader: '', //合同负责人
          strContleaderName: '',
          contractList: [],
          StrContractatta: '' //合同附件
        }], //主体信息数据
        customeridList: [], //选中的客户人员
        picListPro: [], //项目图片
        cascaderTxt: ''
      }
    },
    created() {
      this.getprovinces()
      this.areaCityList = this.$store.state.city
      this.areaProvinceList = this.$store.state.province
      this.proNameQuery.roletype = localStorage.loginRoletype
      this.proNameQuery.strorgancode = localStorage.gancode
      this.listQuery.roletype = localStorage.loginRoletype
      this.listQuery.strorgancode = localStorage.gancode
      this.isEdit = this.$route.query.isEdit
      // 员工
      this.getMemberList('leader')
      // this.getMemberList('other')
      // this.getMemberList('partner')
      // this.getMemberList('member')
      // this.getCustomerList('customer')
      // this.getMemberList('views')
      this.calHeight()
      // 项目名称列表
      this.getProNameList()
      // 客户列表
      this.getCusList()
      // 客户项目等级
      this.getParamList('JB_base_Custprolevel')
      // 业务类型
      this.getParamList('JB_base_Busitype')
      // 社保
      this.getParamList('JB_base_Socialsec')
      // 商保
      this.getParamList('JB_base_Busisec')
      // 签约主体
      this.getParamList('JB_base_Legalsub')
      if (this.isEdit == 'true') {
        this.pageTitle = '编辑项目'
        this.proForm.projectid = this.$route.query.projectid
        this.getDetailData()
        this.getButtonPower();
        this.isDetail = false
      } else if (this.isEdit == 'false') {
        this.pageTitle = '新增项目'
        this.isDetail = false
        // 部门
        this.getDepartList()
      } else if (this.isEdit == 'detail') {
        this.pageTitle = '项目详情'
        this.proForm.projectid = this.$route.query.projectid
        this.getDetailData()
        this.isDetail = true
      }
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/projectList',
          powerEnName: 'projectManage'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight)
      },
      // 强制刷新
      forceChange(val) {
        console.log(1111, val)
        this.$forceUpdate();
      },
      // 新增签约信息
      addHandle(row) {
        let obj = {};
        if (row.strContleader) {
          obj = this.staffList.find((item) => {
            return item.Userid === row.strContleader;
          });
        }
        let obj1 = {};
        if (row.strContractType) {
          obj1 = this.businessList.find((item) => {
            return item.Busitypeid === row.strContractType;
          });
        }
        if (this.isNull(row.strSignsubject)) {
          this.$message({
            type: 'warning',
            message: '请选择签约主体'
          })
          return
        }
        let query = {
          type: 'dtl',
          Subid: row.Subid,
          strSignsubject: row.strSignsubject, //签约主体
          strContractType: row.strContractType, //合同业务类型
          strContractTypeName: row.strContractType ? (obj1 && obj1.StrBusitypeName ? obj1.StrBusitypeName : '') : '',
          dtContractstartDate: row.dtContractstartDate, //合同开始时间
          dtContractendDate: row.dtContractendDate, //合同结束时间
          strContleader: row.strContleader, //合同负责人
          strContleaderName: row.strContleader ? (obj && obj.Username ? obj.Username : '') : '', //合同负责人名称
          contractList: row.contractList ? row.contractList : [], //附件
          StrContractatta: row.StrContractatta //合同附件
        }
        this.tableData.push(query);
        let add = {
          type: 'add',
          Subid: '',
          strSignsubject: '', //签约主体
          strContractType: '', //合同业务类型
          strContractTypeName: '', //合同业务类型名称
          dtContractstartDate: '', //合同开始时间
          dtContractendDate: '', //合同结束时间
          strContleader: '', //合同负责人
          strContleaderName: '',
          contractList: [],
          StrContractatta: '' //合同附件
        }
        this.$set(this.tableData, '0', add)
        // this.tableData[0] = {
        //   type:'add',
        //   Subid:'',
        //   strSignsubject:'',//签约主体
        //   strContractType:'',//合同业务类型
        //   strContractTypeName:'',//合同业务类型名称
        //   dtContractstartDate:'',//合同开始时间
        //   dtContractendDate:'',//合同结束时间
        //   strContleader:'',//合同负责人
        //   strContleaderName: '',
        //   contractList: [],
        //   StrContractatta:''//合同附件
        // }
      },
      // 删除签约信息
      dltHandle(index) {
        this.tableData.splice(index, 1);
      },
      // 下载附件
      downHandle(row) {
        // console.log('dd',row)
        var path = this.imgPath + row.url;
        var aTag = document.createElement("a");
        aTag.download = row.name; //这里写保存时的文件名称
        aTag.href = path;
        aTag.click();
      },
      // 上传项目图片
      handleUpdateChange(file, fileList, dataArr) {
        let formData = new FormData()
        formData.append("action", 'save')
        formData.append("pagename", 'docinf')
        formData.append("userid", Cookies.get("userid-b"))
        formData.append("entid", Cookies.get("userid-b"))
        formData.append("entPicFile", file.raw, file.name)
        console.log('entPicFile', file, fileList)
        xz.uploadCert(formData).then(res => {
          // console.log('entPicFile', res)
          if (res) {
            dataArr.push({
              Picid: '', //文件id
              StrPictureName: file.name, //文件名称
              StrPicture: res //文件路径
            })
          } else {
            this.$message('文件上传失败,请稍后再试')
          }
        })
      },
      handleExceedPic() {
        this.$message.warning(`最多上传10张图片！`);
      },
      //图片预览
      handlePictureCardPreview(file) {
        // console.log(file);
        this.dialogImageUrl = this.docPath + file.StrPicture;
        this.dialogVisiblePic = true;
      },
      //删除图片
      handleRemove(file, data) {
        // console.log(file);
        let arr1 = this.$refs.uploadPro.uploadFiles;
        let index1 = arr1.indexOf(file)
        this.picListPro.splice(index1, 1)
        // console.log('index1',arr1, index1, this.picListPro);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        // isJPG && 
        return isLt2M;
      },
      // 上传主体信息附件
      success_handle(file, fileList, row) {
        console.log(file, fileList, row);
        const formData = new FormData();
        formData.append("pagename", "entimg");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        // console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            row.contractList.push({
              url: res,
              name: file.name
            })
          }
        });
      },
      // 删除单个附件
      dltItemHandle(item, index, data) {
        data.splice(index, 1);
      },
      handleFileRemove(file, fileList, row) {
        // console.log(file, fileList);
        // 删除文件时，从 fileList 中移除对应的文件即可
        row.contractList = row.contractList.filter(item => item.url !== file.url);
        // console.log('file', row.contractList);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制最多上传 3 个文件`);
      },
      //选择地址
      changeAreaHandle(val) {
        console.log('ddd', val)
        if (!this.isNull(val)) {
          // let textArr = []
          // const checkedNode =  this.$refs["cascaderArr"].getCheckedNodes();
          // checkedNode.forEach((i) => {
          //    textArr.push(i.pathLabels);
          //  });
          //  console.log('checkedNode', checkedNode,textArr)
          this.proForm.strRegion = val.join(';');
          // let labels = checkedNode[0].pathLabels
          // if (val.length == 2 || val.length > 2) {
          //   this.proForm.strProProvince = val[0]
          //   this.proForm.strProCity = val[1]
          // }
          // if (val.length == 1) {
          //   this.proForm.strProProvince = val[0]
          //   this.proForm.strProCity = ''
          // }
        } else {
          this.proForm.strProProvince = ''
          this.proForm.strProCity = ''
          this.proForm.strRegion = ''
        }
      },
      //获取省市区
      getprovinces() {
        let that = this;
        xz.getAreaAll().then(res => {
          // console.log('getprovinces', res)
          this.areaList = res;
          if (!this.isNull(this.areaList)) {
            for (const key in this.areaList) {
              // 删除第三层children属性
              for (const i in this.areaList[key].children) {
                delete this.areaList[key].children[i].children
              }
            }
          }
        })
      },
      //根据targetName查询该节点和所有父级节点 回显el-cascader组件的值
      getParentsByName(list, targetName) {
        for (let i in list) {
          if (list[i].Name.indexOf(targetName) > -1) {
            //查询到就返回该数组对象
            return [list[i]]
          }
          if (list[i].children) {
            let node = this.getParentsByName(list[i].children, targetName)
            if (node !== undefined) {
              //查询到把父节点连起来
              return node.concat(list[i])
            }
          }
        }
      },
      //确定保存
      submitForm(formName) {
        let that = this
        if (this.isLeaderChange == false) {
          this.proForm.strContleader = this.dtlOneQuery.strContleader
        }
        if (this.isproManagerChange == false) {
          this.proForm.strProManager = this.dtlOneQuery.strProManager
        }
        if (this.isStrpartner2Change == false) {
          this.proForm.strpartner2 = this.dtlOneQuery.strpartner2
        }
        if (!this.isNull(this.proForm.editCusIds)) {
          this.proForm.strservuserid = this.proForm.editCusIds.toString()
        } else {
          this.proForm.strservuserid = ''
        }
        if (this.isAchieveownerChange == false) {
          this.proForm.strAchieveowner = this.dtlOneQuery.strAchieveowner
        }
        if (this.isPartnerSelChange == false) {
          this.proForm.strpartner = this.dtlOneQuery.strpartner
        }
        if (this.proForm.busInsuranceList) {
          this.proForm.busInsurance = this.proForm.busInsuranceList.toString();
        }
        if (this.proForm.socialInsuranceList) {
          this.proForm.socialInsurance = this.proForm.socialInsuranceList.toString();
        }
        if (this.viewidList) {
          this.proForm.strViewids = this.viewidList.toString();
        }
        if (this.customeridList) { // 客户人员
          this.proForm.StrCustomerid = this.customeridList.toString();
        }
        let subData = []; //主体信息
        if (this.tableData && this.tableData.length > 0) {
          for (let i = 0; i < that.tableData.length; i++) {
            let elements = that.tableData[i];
            if (elements.type == 'dtl') { //加进去的数据 传大写 显示小写
              subData.push({
                Subid: elements.Subid,
                StrSignsubject: elements.strSignsubject, //签约主体
                StrContractType: elements.strContractType, //合同业务类型
                DtContractstartDate: elements.dtContractstartDate, //合同开始时间
                DtContractendDate: elements.dtContractendDate, //合同结束时间
                StrContleader: elements.strContleader, //合同负责人
                StrContractatta: JSON.stringify(elements.contractList) //合同附件
              })
            }
          }
          if (subData && subData.length > 0) { //旧的默认赋值第一条数据
            that.proForm.strSignsubject = subData[0].StrSignsubject ? subData[0].StrSignsubject : '';
            that.proForm.strContractType = subData[0].StrContractType ? subData[0].StrContractType : '';
            that.proForm.dtContractstartDate = subData[0].DtContractstartDate ? subData[0].DtContractstartDate : '';
            that.proForm.dtContractendDate = subData[0].DtContractendDate ? subData[0].DtContractendDate : '';
            that.proForm.strContleader = subData[0].StrContleader ? subData[0].StrContleader : '';
          } else {
            that.proForm.strSignsubject = '';
            that.proForm.strContractType = '';
            that.proForm.dtContractstartDate = '';
            that.proForm.dtContractendDate = '';
            that.proForm.strContleader = '';
          }
        } else {
          subData = []
        }
        this.btnLoading = true
        // console.log('submitForm',this.proForm,subData,this.picListPro)
        that.$refs[formName].validate((valid) => {
          if (valid) {
            xz.bsaveJbProjectversion1(that.proForm, subData, that.picListPro).then(res => {
              if (res.status == 'ok') {
                that.$message({
                  message: "保存成功",
                  type: "success"
                })
                that.$router.push({
                  path: '/projectList'
                })
              } else {
                that.$message({
                  message: res.msg,
                  type: "error"
                })
              }
              this.btnLoading = false
            })
          } else {
            console.log('error submit!!')
            this.btnLoading = false
            return false
          }
        })
      },
      // 查找出城市对应码
      getCityCode(data, val) {
        // console.log('lll',data)
        let cityArr = data.filter(element =>
          element.name == val + '市'
        )
        return cityArr
      },
      // 合同负责人change
      contleaderChange(val) {
        // console.log('select改变', val)
        this.isLeaderChange = true
      },
      // 项目管理员
      proManagerChange(val) {
        if (this.isNull(val)) {
          this.dtlOneQuery.strProManager = ''
        }
        this.isproManagerChange = true
      },
      // 合伙人
      strpartner2Change(val) {
        if (this.isNull(val)) {
          this.dtlOneQuery.strContleader = ''
        }
        this.isStrpartner2Change = true
      },
      // 客服
      servuserChange(val) {
        // console.log('vvv',val)
        if (this.isNull(val)) {
          this.dtlOneQuery.strservuserid = ''
          this.proForm.editCusIds = []
        } else {
          // 判断是否是登录人员的上下级
          this.rankHandle(val[Number(val.length) - 1])
          this.dtlOneQuery.strservuserid = val.toString()
        }
        this.isServuserChange = true
        this.proForm.strservuserid = val.toString();
      },
      // 判断是否是登录人员的上下级
      rankHandle(checkuserid) {
        xz.checkProStrservuserid(checkuserid).then(res => {
          if (res.status == 'ok') {
            if (res.msg == 'false') {
              this.selServiceList.push(res.username)
              this.$message({
                type: 'warning',
                message: '温馨提示:' + res.username + '客服非您负责区域的客服人员,请确认！',
                center: true,
                duration: 2500
              });
            }
            this.selServiceList = [...new Set(this.selServiceList)]
          }
        })
      },
      // 业绩归属人
      achieveownerChange(val) {
        if (this.isNull(val)) {
          this.dtlOneQuery.strAchieveowner = ''
        }
        this.isAchieveownerChange = true
      },
      // 业务团队长
      partnerSelChange(val) {
        if (this.isNull(val)) {
          this.dtlOneQuery.strpartner = ''
        }
        this.isPartnerSelChange = true
      },
      // 部门选择
      handleSectionChange(value) {
        // console.log(value)
        this.proForm.strservuserid = ''
        if (value.length >= 3) {
          this.proForm.strDep1 = value[0]
          this.proForm.strDep2 = value[1]
          this.proForm.strDep3 = value[2]
        }
        if (value.length == 2) {
          this.proForm.strDep1 = value[0]
          this.proForm.strDep2 = value[1]
          this.proForm.strDep3 = ''
        }
        if (value.length == 1) {
          this.proForm.strDep1 = value[0]
          this.proForm.strDep2 = ''
          this.proForm.strDep3 = ''
        }
        if (this.isNull(value)) {
          this.proForm.strDep1 = ''
          this.proForm.strDep2 = ''
          this.proForm.strDep3 = ''
        }

        let dep = this.$refs.dep.getCheckedNodes(true)[0];
        if (dep != undefined && dep.data.strHandleid) {
          this.viewidList.push(dep.data.strHandleid)
        }
        // this.departQuery.strorgancode = value[Number(value.length)-1]
        // this.departQuery.roletype = localStorage.loginRoletype
        // this.getCustomerList('customer')
      },
      // 业绩归属部门选择
      perSectionChange(val) {
        // console.log('业绩归属部门', val)
        if (this.isNull(val)) {
          this.proForm.strbusdep = ''
        } else {
          this.proForm.strbusdep = val[Number(val.length) - 1]
        }
      },
      // 业绩归属人部门选择
      ownerSectionChange(val) {
        // console.log('业绩归属人部门', val)
        // this.proForm.strAchieveowner = ''
        // this.departQuery.strorgancode = val[Number(val.length)-1]
        // this.departQuery.roletype = localStorage.loginRoletype
        // this.getMemberList('member')
        if (this.isNull(val)) {
          this.proForm.strAchievedep = ''
        } else {
          this.proForm.strAchievedep = val[Number(val.length) - 1]
        }
      },
      // 选择项目名称
      handleSelect(item) {
        console.log(item)
      },
      // 修改社保
      socialChange(val) {
        // console.log('kkk', val)
        if (this.isNull(val)) {
          this.$set(this.proForm, this.proForm.socialInsuranceList, [])
          this.$set(this.proForm, this.proForm.socialInsurance, '')
        } else {
          this.$set(this.proForm, this.proForm.socialInsuranceList, val)
          this.$set(this.proForm, this.proForm.socialInsurance, val.toString())
        }
      },
      // 修改商保
      busChange(val) {
        if (this.isNull(val)) {
          this.$set(this.proForm, this.proForm.busInsuranceList, [])
          this.$set(this.proForm, this.proForm.busInsurance, '')
        } else {
          this.$set(this.proForm, this.proForm.busInsuranceList, val)
          this.$set(this.proForm, this.proForm.busInsurance, val.toString())
        }
      },
      // 匹配项目名称
      querySearch(queryString, cb) {
        let proNameLists = this.proNameList;
        let results = queryString ? proNameLists.filter(this.createFilter(queryString)) : proNameLists;
        // 调用 callback 返回建议列表的数据
        cb(results)
      },
      createFilter(queryString) {
        return (res) => {
          return (res.StrprojectName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      // 选择区域
      changeArea(datas) {
        // console.log('changeArea', datas)
        // 区域code
        let dataCode = ''
        if (datas.area) {
          dataCode = datas.area.code
        } else if (datas.city) {
          dataCode = datas.city.code
        } else {
          dataCode = datas.province.code
        }
        this.proForm.strProCity = datas.city.name
        this.proForm.strProProvince = datas.province.name
        this.proForm.strRegion = dataCode
      },
      // 返回上一页
      backHandle() {
        this.$router.go(-1)
      },
      // 项目详情
      getDetailData() {
        this.listLoading = true
        let that = this
        that.selected = []
        if (that.isEdit == 'detail') {
          that.tableData = []
        }
        xz.getProjectDetailversion1(this.proForm.projectid).then(async (res) => {
          // console.log('详情', res)
          if (res.status == 'ok') {
            let jsonres = JSON.parse(res.msg);
            this.proForm = {
              projectid: jsonres.Projectid, //项目id
              strprojectName: jsonres.StrprojectName, //项目名称
              custid: jsonres.Custid, //客户id
              dtInitDate: jsonres.DtInitDate, //立项时间
              strSignsubject: jsonres.StrSignsubject, //签约主体
              strContractType: jsonres.StrContractType, //合同业务类型
              actualtype: jsonres.Actualtype, //业务类型
              strprojectlevel: jsonres.Strprojectlevel, //项目等级
              strProProvince: jsonres.StrProProvince, //省
              strProCity: jsonres.StrProCity, //市
              strbusdep: jsonres.Strbusdep, //业绩归属部门
              // strbussondep: jsonres.Strbussondep, //业绩归属子部门
              strpartner: jsonres.Strpartnername, //业务团队长
              strpartner2: jsonres.Strpartner2name, //合伙人
              strAchieveowner: jsonres.StrAchieveownername, //业绩归属人
              strAchievedep: jsonres.StrAchievedep, //业绩归属人部门
              strservuserid: jsonres.Strservuserid, //客服
              editCusIds: (!that.isNull(jsonres.Strservuserid)) ? jsonres.Strservuserid.split(',') : [],
              strProManager: jsonres.StrProManagername, //项目管理员
              strBusiStat: jsonres.StrBusiStat, //项目状态
              strrecruit: jsonres.Strrecruit, //是否招聘
              strTransfer: jsonres.StrTransfer, //是否转移
              strHighRisk: jsonres.StrHighRisk, //协议高风险
              strNewadd: jsonres.StrNewadd, //是否新增
              socialInsurance: jsonres.SocialInsurance, //社保
              busInsurance: jsonres.BusInsurance, //商保
              decRiskfund: jsonres.DecRiskfund, //  风险计提金
              strinvoiceType: jsonres.StrinvoiceType, //开票方式
              strInvoicecontent: jsonres.StrInvoicecontent, //发票内容
              strBillmethod: jsonres.StrBillmethod, // 发票类型
              dtpaydate: jsonres.Dtpaydate, //发薪日期
              isAdvMoney: jsonres.IsAdvMoney, //是否垫资
              dtEndDate: jsonres.DtEndDate, //项目终止时间
              dtContractstartDate: jsonres.DtContractstartDate, //合同开始时间
              dtContractendDate: jsonres.DtContractendDate, //合同结束时间
              strContleader: jsonres.StrContleadername, //合同负责人
              strDep1: jsonres.StrDep1, //部门一级
              strDep2: jsonres.StrDep2, //部门二级
              strDep3: jsonres.StrDep3, //部门三级
              strRegion: jsonres.StrRegion, //地区码
              strViewids: jsonres.StrViewids,
              StrCustomerid: jsonres.StrCustomerid, //客户人员
              StrIntroduct: jsonres.StrIntroduct //简介
            }
            let arr = [];
            that.$refs.cascaderArr.computePresentText(); // 赋值选不中处理
            if (!that.isNull(that.proForm.strRegion)) {
              if (that.proForm.strRegion.indexOf(';') > -1) {
                arr = that.proForm.strRegion.split(';');
                for (let j = 0; j < arr.length; j++) {
                  let element = arr[j];
                  let ele = element.split(',');
                  that.selected.push(ele);
                }
              } else {
                arr = that.proForm.strRegion.split(',');
                that.selected.push(arr);
              }
            } else {
              that.selected = [];
            }
            that.cascaderTxt = jsonres.StrRegion;
            // console.log('11',that.selected)
            this.dtlOneQuery = {
              strpartner: jsonres.Strpartner, //业务团队长
              strpartner2: jsonres.Strpartner2, //合伙人
              strAchieveowner: jsonres.StrAchieveowner, //业绩归属人
              strservuserid: jsonres.Strservuserid, //客服
              strProManager: jsonres.StrProManager, //项目管理员
              strContleader: jsonres.StrContleader, //合同负责人
            }
            // if(jsonres.StrAchievedep){
            // this.departQuery.strorgancode = jsonres.StrAchievedep
            // this.departQuery.roletype = localStorage.loginRoletype
            // this.getMemberList('member')
            // }
            // 部门
            await this.getDepartList()
            if (jsonres.BusInsurance) {
              this.proForm.busInsuranceList = jsonres.BusInsurance.split(',')
            }
            if (jsonres.SocialInsurance) {
              this.proForm.socialInsuranceList = jsonres.SocialInsurance.split(',')
            }
            if (jsonres.StrViewids) {
              this.viewidList = jsonres.StrViewids.split(',')
            }
            if (jsonres.StrCustomerid) {
              this.customeridList = jsonres.StrCustomerid.split(',');
            }
            this.dedpartNameList = [jsonres.StrDep1, jsonres.StrDep2, jsonres.StrDep3]
            // 去除空值
            this.dedpartNameList = this.dedpartNameList.filter(function (s) {
              return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
            })
            let msgpic = res.msgpic;
            let msgsub = res.msgsub;
            if (msgpic && msgpic.length > 0) { // 项目图片
              for (let i = 0; i < msgpic.length; i++) {
                let element1 = msgpic[i];
                that.picListPro.push({
                  Picid: element1.Picid,
                  StrPicture: element1.StrPicture,
                  StrPictureName: element1.StrPictureName
                })
              }
            }
            if (msgsub && msgsub.length > 0) { // 主体信息
              for (let i = 0; i < msgsub.length; i++) {
                let element2 = msgsub[i];
                let obj = {};
                let obj1 = {};
                if (element2.StrContleader) {
                  obj = that.staffList.find((item) => {
                    return item.Userid === element2.StrContleader;
                  });
                }
                if (element2.StrContractType) {
                  obj1 = that.businessList.find((item) => {
                    return item.Busitypeid === element2.StrContractType;
                  });
                }
                that.tableData.push({
                  type: 'dtl',
                  Subid: element2.Subid,
                  strSignsubject: element2.StrSignsubject, //签约主体
                  strContractType: element2.StrContractType, //合同业务类型
                  strContractTypeName: element2.StrContractType ? (obj1 && obj1.StrBusitypeName ? obj1.StrBusitypeName : '') : '',
                  dtContractstartDate: element2.DtContractstartDate ? element2.DtContractstartDate.substring(0, 10) : '', //合同开始时间
                  dtContractendDate: element2.DtContractendDate ? element2.DtContractendDate.substring(0, 10) : '', //合同结束时间
                  strContleader: element2.StrContleader, //合同负责人ID
                  strContleaderName: element2.StrContleader ? (obj && obj.Username ? obj.Username : '') : '', //合同负责人名称
                  contractList: element2.StrContractatta ? JSON.parse(element2.StrContractatta) : [], //附件
                  StrContractatta: element2.StrContractatta //合同附件
                })
              }
            }
            // 客服
            // if(jsonres.StrDep1){
            // this.departQuery.strorgancode = this.dedpartNameList[Number(this.dedpartNameList.length)-1]
            // this.getCustomerList('customer')
            // }
          }
          this.listLoading = false
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
      },
      // 客户列表
      getCusList() {
        xz.getCustLists(this.listQuery).then(res => {
          // console.log('客户', res)
          if (res.status == 'ok') {
            this.customList = res.msg
          } else {
            this.customList = []
          }
        })
      },
      // 获取项目名称列表
      getProNameList() {
        xz.getProjectLists(this.proNameQuery).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            this.proNameList = res.msg
          } else {
            this.proNameList = []
          }
        })
      },
      // 获取部门列表
      getDepartList() {
        let perDepartArr = []
        let perOwnerArr = []
        // this.perDepartList = []
        // this.perOwnerList = []
        let perLength = 0
        let ownerLength = 0
        this.departQuery.strorgancode = ''
        this.departQuery.roletype = ''
        xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
          strIsDisable: '1'
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children
            }
            if (this.isEdit != 'false') {
              // console.log('详情', this.departList, this.proForm.strbusdep)
              if (this.departList != []) {
                // 业绩归属部门
                perDepartArr = this.getParentsById(this.departList, this.proForm.strbusdep)
                // 业绩归属人部门
                perOwnerArr = this.getParentsById(this.departList, this.proForm.strAchievedep)
                // console.log('部门', perDepartArr)
                // if(perDepartArr != undefined){
                //   perLength = Number(perDepartArr.length)
                // }
                // if(perOwnerArr != undefined){
                //   ownerLength = Number(perOwnerArr.length)
                // }
                if (perDepartArr != undefined && perDepartArr.length > 0) {
                  for (let i = 0; i < perDepartArr.length; i++) {
                    const elementDep = perDepartArr[i];
                    this.perDepartList.push(elementDep.strorgancode)
                  }
                  this.perDepartList = this.perDepartList.reverse()
                } else {
                  this.perDepartList = []
                }
                if (perOwnerArr != undefined && perOwnerArr.length > 0) {
                  for (let j = 0; j < perOwnerArr.length; j++) {
                    const elementDep = perOwnerArr[j];
                    this.perOwnerList.push(elementDep.strorgancode)
                  }
                  this.perOwnerList = this.perOwnerList.reverse()
                } else {
                  this.perOwnerList = []
                }
                // console.log('部门', this.perDepartList)
              }
            }
          } else {
            this.departList = []
          }
        })
      },
      // 获取员工列表
      getMemberList(type) {
        xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            // if(type == 'leader'){
            this.leaderList = res.msg
            // }else if(type == 'member'){
            this.memberList = res.msg
            // }else if(type == 'other'){
            // 员工列表
            this.staffList = res.msg
            // }else if(type == 'partner'){
            // 合伙人列表
            this.partnerList = res.msg
            // }else if(type == 'views'){
            // 项目查看人列表
            this.viewsList = res.msg
            this.customerList = res.msg
            // }
          } else {
            // if(type == 'leader'){
            // 业务团队长列表
            this.leaderList = []
            // }else if(type == 'member'){
            // 业绩归属人列表
            this.memberList = []
            // }else if(type == 'other'){
            // 员工列表
            this.staffList = []
            // }else if(type == 'partner'){
            // 合伙人列表
            this.partnerList = []
            // }else if(type == 'views'){
            // 项目查看人列表
            this.viewsList = []
            // 客服列表
            this.customerList = []
            // }
          }
        })
      },
      // 获取客服列表
      // getCustomerList(type){
      //   xz.getUserInfoBytoporgancode(this.departQuery.strorgancode,this.departQuery.roletype,this.departMemberQuery).then(res => {
      //     // console.log('员工', res)
      //     if (res.status == 'ok') {
      //       if(type == 'customer'){
      //         this.customerList = res.msg
      //       }else{
      //         // 客服列表
      //         this.customerList = []
      //       }
      //     }
      //   })
      // },
      // 获取参数列表(等级)
      getParamList(type) {
        this.paramQuery.strtableid = type
        xz.getParameterList(this.paramQuery).then(res => {
          // console.log('参数', res)
          if (res.status == 'ok') {
            // 客户项目等级
            if (type == 'JB_base_Custprolevel') {
              this.levelList = res.msg
            } else if (type == 'JB_base_Busitype') {
              // 业务类型
              this.businessList = res.msg
            } else if (type == 'JB_base_Socialsec') {
              // 社保
              this.socialSecurityList = res.msg
            } else if (type == 'JB_base_Busisec') {
              // 商保
              this.insuranceList = res.msg
            } else if (type == 'JB_base_Legalsub') {
              // 签约主体
              this.legalList = res.msg
            }
          } else {
            if (type == 'JB_base_Custprolevel') {
              this.levelList = []
            } else if (type == 'JB_base_Busitype') {
              // 业务类型
              this.businessList = []
            } else if (type == 'JB_base_Socialsec') {
              // 社保
              this.socialSecurityList = []
            } else if (type == 'JB_base_Busisec') {
              // 商保
              this.insuranceList = []
            } else if (type == 'JB_base_Legalsub') {
              // 签约主体
              this.legalList = []
            }
          }
        })
      },
      //根据id查询该节点和所有父级节点 回显el-cascader组件的值
      getParentsById(list, id) {
        for (let i in list) {
          if (list[i].strorgancode === id) {
            //查询到就返回该数组对象
            return [list[i]]
          }
          if (list[i].children) {
            let node = this.getParentsById(list[i].children, id)
            if (node !== undefined) {
              //查询到把父节点连起来
              return node.concat(list[i])
            }
          }
        }
      },
      changeTab() {
        if (this.activeName == '1') {
          this.$router.push({
            path: '/acSet',
            query: {
              projectid: this.proForm.projectid
            }
          })
        }
      }
    }
  };
</script>
<style>
  .p_pro_table .el-cascader__search-input::placeholder {
    color: #606266;
  }

  .p_pro_table .page_table_box .el-table .el-table__cell {
    padding: 5px 0;
  }

  .p_pro_table .page_table_box .el-date-editor.el-input,
  .p_pro_table .page_table_box .el-select {
    width: 150px;
  }

  .p_pro_content .p_pro_table .el-input__inner {
    width: 100%;
  }

  .p_pro_content .p_pro_table .pro-form-inline .el-date-editor.el-input {
    width: 300px;
  }

  .pro_area .trigger_select {
    height: 40px !important;
  }

  .pro_area .delete_value {
    top: 12px !important;
  }

  .p_pro_table .el-date-editor.el-input,
  .p_pro_table .el-select,
  .p_pro_table .el-cascader .el-input {
    width: 300px;
  }

  .p_pro_table .el-form--inline .el-form-item__content,
  .pro_area .xz_con,
  .p_pro_table .el-cascader {
    width: 300px !important;
  }

  .p_pro_table .xz_tabs li:nth-child(3) {
    display: none;
  }

  /* .p_pro_table .xz_total_domain div:nth-child(3){
  display: none;
} */
</style>
<style scoped>
  .info_pic_box {
    display: flex;
    flex-wrap: wrap;
  }

  .info_pic_item {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .f_txt {
    font-size: 13px;
    color: #333;
    margin-top: 3px;
    display: flex;
    align-items: center;
  }

  .w_txt {
    width: 120px;
    /* 设置容器宽度 */
    overflow: hidden;
    /* 隐藏溢出的文本 */
    white-space: nowrap;
    /* 防止文本换行 */
    text-overflow: ellipsis;
    /* 溢出部分用省略号表示 */
    cursor: pointer;
    text-decoration: underline;
  }

  .f_txt .err_icon {
    font-size: 16px;
    color: #bcb7b7;
    margin-left: 15px;
    cursor: pointer;
  }

  .mt15 {
    margin-top: 15px;
  }

  .page_btn_box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .page_title_box {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .p_line {
    width: 3px;
    height: 16px;
    background-color: #FF5500;
    margin-right: 6px;
  }

  .p_line_title {
    font-size: 16px;
    color: #333;
  }

  .p_pro_table {
    padding: 30px 20px;
    background-color: #fff;
  }

  .el-pagination {
    background-color: #fff;
  }
</style>